import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../data/Axios/DynamicForm";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";
import { companyManagementUrl } from "../../../config";
import { fetchJsonDynamic } from "../../../data/DynamicServiceNew/jsondynamicservice";

const base_url = companyManagementUrl.uri;

const DIYForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);

  const initialValues = {
    trialDays: props.data ? props.data.TrialDays : "",
  };

  const fields = [
    {
      name: "trialDays",
      label: "Trial Days",
      type: "number",
      gridColumn: "span 2",
      required: false,
    },
  ];
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { 
        trialDays, 
      } = values;

      const mutationData = props.isEditing
        ? {
            companyIds: props.data.Id,
            days:trialDays,
          }
        : {
            days:trialDays,
          };

      const response = await generateAndExecuteMutation(
        "updateDiyTrialDays",
        mutationData,
        "",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Trial Days ${"updated"} successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={"Edit Trial Days"}
      subtitle={"Edit an Existing trial days for a company"}
    />
  );
};

export default DIYForm;
